import type {GridColType} from '@mui/x-data-grid-pro';
import {assert} from 'assert-ts';
import type {Cardinality} from 'schemaDefinition/types';

export const mapType = (
  schemaPartType?: string,
  cardinality?: Cardinality,
): GridColType => {
  assert(
    schemaPartType !== undefined,
    'mapPartToColumns missing schemaPartType',
  );

  switch (schemaPartType) {
    case 'int':
    case 'year':
      if (cardinality === 'multiple' || cardinality === '2') {
        return 'string';
      }
      return 'number';
    case 'text':
      return 'string';
    case 'date':
      if (cardinality === 'multiple' || cardinality === '2') {
        return 'string';
      }
      return 'date';
    case 'codelist':
      return 'singleSelect';
    default:
      return 'string';
  }
};
